export const GRADE_TO_FILTER_CODE = ['G02996'];
